<template>
    <div class="inner-loader" :style="{'z-index': zIndex}">
        <div class="lds-ripple">
            <div :style="{color: color}"></div>
            <div :style="{color: color}"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: '#ef0000'
        },
        zIndex: {
            type: Number,
            default: 99
        }
    }
}
</script>

<style>
.inner-loader {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    background-color: rgba(255, 255, 255, .7);
    z-index: 99;
}
.lds-ripple {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.lds-ripple div {
    position: absolute;
    border: 4px solid;
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
    animation-delay: -0.5s;
}
@keyframes lds-ripple {
    0% {
        top: 36px;
        left: 36px;
        width: 0;
        height: 0;
        opacity: 1;
    }
    100% {
        top: 0px;
        left: 0px;
        width: 72px;
        height: 72px;
        opacity: 0;
    }
}
</style>
